module.exports = __webpack_public_path__ + "img/banner-differents.d391713c.jpg";